import { render, staticRenderFns } from "./UndoIcon.vue?vue&type=template&id=e60857fa&scoped=true&functional=true&"
import script from "./UndoIcon.vue?vue&type=script&lang=js&"
export * from "./UndoIcon.vue?vue&type=script&lang=js&"
import style0 from "./UndoIcon.vue?vue&type=style&index=0&id=e60857fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "e60857fa",
  null
  
)

export default component.exports